import React from "react";
import chPlayImg from "../../assets/ch_play.png";
import googlePlayImg from "../../assets/google_play.png";

const ChPlayComponent = () => {
  return (
    <>
      <p className="title">決済方法</p>
        <a href="https://play.google.com/store/apps/details?id=com.monaka.foodi&hl=ja" className="ch-play-link">
            <img src={chPlayImg} alt="GooglePlay決済" />
            <p className="ch-play-title">GooglePlay決済</p>
            <p className="ch-play-subtitle">GooglePlay決済が利用可能です。</p>
        </a>
      <a href="https://play.google.com/store/apps/details?id=com.monaka.foodi&hl=ja" className="google-play-store">
        <img src={googlePlayImg} alt="GooglePlay決済" />
      </a>
    </>
  );
};
export default ChPlayComponent;